// src/services/specialtyService.js
// Service pour gérer les spécialités

import api from './api';

const specialtyService = {
  /**
   * Récupérer toutes les spécialités
   * @returns {Promise<Array>} Liste des spécialités
   */
  async getAllSpecialties() {
    try {
      const response = await api.get('/public/salons/specialties');
      
      // Format : { success: true, data: [...] }
      return response.data.data || [];
    } catch (error) {
      console.error('Erreur lors de la récupération des spécialités:', error);
      throw error;
    }
  },
};

export default specialtyService;